<template>
  <Suspense>
    <RouterView />
  </Suspense>
</template>
